<template>
	<div v-if="appLoaded"	
			id="app" 
			:class="`page-${$route.name} ${appMediaQuery}`">
		<app-header />
		<app-nav :class="{'fixed': fixedNav}"/>
		
		<!-- 
		TODO: fix or bin,
		<p>fixedNav: {{fixedNav ? 'yyyy' : 'nnnn'}}</p> 
		-->
		
		<router-view/>
		<app-footer />
		<app-cookie-message v-if="appCookieUnset" />
	</div>
	<div v-else><p>Loading Argos Fire & Safety .... </p></div>
</template>

<script>
import AppFooter from './public/AppFooter'
import AppHeader from './public/AppHeader'
import AppNav from './public/AppNav'
import AppCookieMessage from '@/features/app/components/AppCookieMessage'

// TODO: move this to ./public and rename Layout
// TODO: not needed here??
import LayoutManager from './LayoutManager'

import FilesGallery from '@/features/files/components/public/FilesGallery'
import PageContent from '@/features/pages/components/public/PageContent'
import ProductBrandContent from '@/features/products/components/public/ProductBrandContent'
import Vue from 'vue'
import throttle from 'lodash/throttle'
import { appComputed, appMethods } from '@/features/app/store'
import { pagesComputed } from '@/features/pages/store'
import '@/assets/css/public/main.scss'

// TODO: see above
Vue.component('layout-manager', LayoutManager)

Vue.component('files-gallery', FilesGallery)
Vue.component('page-content', PageContent)
Vue.component('product-brand-content', ProductBrandContent)
Vue.component('snippet-content', {
	props: ['slug'],
	template: `<component :is="{template: '#'+slug}" />`
})

export default {
	components: {
		AppFooter,
		AppHeader,
		AppNav,
		AppCookieMessage
	},
	data: () => ({
		fixedNav: false
	}),
	mounted() {
		this.appMediaQueryInit()
		window.addEventListener("scroll", throttle(this.doUpdateScrollState, 300))
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.doUpdateScrollState)
	},
	computed: {
		...appComputed,
		...pagesComputed
	},
	methods: {
		...appMethods,
		// TODO: add listener to nav, if it is not all visible then add style
		doUpdateScrollState() {
			this.fixedNav = window.scrollY > 193			
		}
	},
	watch: {
		$route: function() {
			const slug = this.$route.fullPath.substring(1)
			const page = this.pages.find(page => page.slug == slug)
			if (!page) return
			document.querySelector('head meta[name=description]').setAttribute('content', page.seoDescription)
			document.querySelector('head meta[name=tags]').setAttribute('content', page.seoTags)
		}
	}
};
</script>
